module.exports = __webpack_public_path__ + "static/media/2025_2026_TMEA_Region_20_Band_Policies.329d883f.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/25-26/2025_2026_TMEA_Region_20_Band_Policies.pdf
// module id = 253
// module chunks = 0